export const pl = {
  addressForm: {
    searchLabel: 'Wyszukaj adres',
    searchPlaceholder: 'Zacznij wpisywać adres...',
    detailsLabel: 'Adres na wizytówce',
    detailsEmpty: 'Uzupełni się po wyborze adresu z listy',
    editManually: 'Popraw ręcznie',
    enterManually: 'Wpisz ręcznie',
    collapseDetails: 'Zwiń',
    manualEntryHint: 'Jeśli poprawisz adres ręcznie, pinezkę na mapie ustalimy na jego podstawie przy zapisie.',
    streetLabel: 'Ulica i numer',
    streetPlaceholder: 'np. Sosnowa 12',
    postalCodeLabel: 'Kod pocztowy',
    postalCodePlaceholder: 'np. 00-001',
    cityLabel: 'Miejscowość',
    cityPlaceholder: 'np. Warszawa',
  },
} as const;
